import React from 'react';

const ThumbnailCardContext = React.createContext({
  active: null,
  setActive: () => {},
});

export default ThumbnailCardContext;
